var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBookIconActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8334 14.2V4.14168C18.8334 3.14168 18.0167 2.40001 17.0251 2.48335H16.9751C15.2251 2.63335 12.5667 3.52502 11.0834 4.45835L10.9417 4.55001C10.7001 4.70001 10.3001 4.70001 10.0584 4.55001L9.85008 4.42502C8.36675 3.50002 5.71675 2.61668 3.96675 2.47501C2.97508 2.39168 2.16675 3.14168 2.16675 4.13335V14.2C2.16675 15 2.81675 15.75 3.61675 15.85L3.85841 15.8833C5.66675 16.125 8.45841 17.0417 10.0584 17.9167L10.0917 17.9333C10.3167 18.0583 10.6751 18.0583 10.8917 17.9333C12.4917 17.05 15.2917 16.125 17.1084 15.8833L17.3834 15.85C18.1834 15.75 18.8334 15 18.8334 14.2Z",
    stroke: "#6F8BDF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 4.82501V17.325",
    stroke: "#6F8BDF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95825 7.32501H5.08325",
    stroke: "#6F8BDF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.58325 9.82501H5.08325",
    stroke: "#6F8BDF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookIconActive);
export default __webpack_public_path__ + "static/media/book-icon-active.f3a7672b25428f3597e2a640a8c6769f.svg";
export { ForwardRef as ReactComponent };